const TestListAddFolderIcon = (props) => (
  <span className="testCasesHierarchicalListAddFolderIconContainer">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9.17 6L11.17 8H20V18H4V6H9.17ZM10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4Z" fill="#2D4356"/>
      <path d="M11 17V14H8V12H11V9H13V12H16V14H13V17H11Z" fill="#2D4356"/>
    </svg>
  </span>
)

export default TestListAddFolderIcon